import React from 'react'
import TextField from 'material-ui/TextField';

const FormHidden = ({ input, label, meta: { touched, error }, ...custom }) => {
  return (
  <TextField
    hintText={label}
    floatingLabelText={label}
    errorText={touched && error}
    style={{display: 'none'}}
    {...input}
    {...custom}
  />
)}

export default FormHidden


// WEBPACK FOOTER //
// ./src/components/FormHidden.js